// @ts-expect-error fixme later
import { StoryType } from '@beef/smart-kit/components/Stories/types';

import { handleYmAnalytics } from 'utils';

const handleStoriesAnalytics = (params: any): void => {
  handleYmAnalytics({
    banners_ev_: {
      stories_elk: params,
    },
  });
};

type analyticsActionType = 'click' | 'open' | 'view_internal_stories';

type storyClickAnalyticsType = {
  action: analyticsActionType;
  index: number;
  title: string;
  url: null | string;
};

export const handleStoryDetailAnalytics = ({
  index,
  title,
  url = null,
  action,
}: storyClickAnalyticsType) => {
  handleStoriesAnalytics({
    [action]: {
      position: {
        [`stories_${index}`]: {
          [title]: url,
        },
      },
    },
  });
};

type listItemType = {
  [position: string]: {
    [title: string]: [url: string];
  };
};

export const handleStoryView = ({ list }: { list: listItemType[] }) => {
  handleStoriesAnalytics({
    view: {
      list,
    },
  });
};

export const getIndex = (stories: StoryType[], id: number) =>
  stories.findIndex((item) => item.id === id);
